import { render, staticRenderFns } from "./print_card.vue?vue&type=template&id=2f757ea5&lang=pug&"
import script from "./print_card.vue?vue&type=script&lang=js&"
export * from "./print_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports